export default {
  created() {
    if (!this.invoices) {
      this.$store.dispatch('INIT_INVOICES');
    }
  },
  methods: {
    goTo(url) {
      window.open(url,'_blank');
    }
  }
};
